import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
  TemplateRef,
  ViewChildren,
  QueryList,
  OnDestroy
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {
  BaseControl,
  ColumnaMaestra,
  Control,
  EstructuraEspecifica,
  Forma,
  Option,
  Static,
  SubForma,
  ValoresEspecificos,
  DynamicFormComponent
} from '@app/shared';
import { LoaderComponent } from '@app/shared/loader/loader.component';
import { filter, find, findIndex } from 'lodash';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { CreationFormComponent } from '../creation-form/creation-form.component';
import { CreationDynamicComponentDataService } from '../shared/creation-dynamic-component.data.service';
import { DynamicFormsFormService } from './shared/dynamic-forms.form.service';

@Component({
  selector: 'iw-dynamic-forms',
  templateUrl: './dynamic-forms.component.html',
  styleUrls: ['./dynamic-forms.component.scss'],
  providers: [
    DynamicFormsFormService,
    CreationDynamicComponentDataService
  ]
})
export class DynamicFormsComponent implements OnInit, OnDestroy {

  // Identificador del formulario padre
  @Input() idForm: number;
  // Orden del formulario dentro de la forma
  @Input() order: number;
  // Id del componente
  @Input() idComponent: number;
  // Define si la accion a realiza es agregar o modificar
  @Input() addForm = true;
  // Formulario
  @Input() formI: SubForma;
  // Identificador de el formulario
  @Input() formPrincipalI: Forma;
  formPrincipal: Forma;
  // Identificador del formulario principal
  idFormulario = 0;
  // Contiene el id del formulario seleccionado
  idFormSeletc = 0;
  // Define cuando esta cargando un formulario
  loading = false;
  // Contiene el formulario seleccionado
  formSelect: SubForma;
  // formulario que valiada el alias
  formTabs: FormGroup = new FormGroup({
    formTab: new FormControl()
  });
  // Referencia de la modal
  modalRef: BsModalRef;
  // Contiene las templates del formulario de creacion de pestaña
  templates = {};
  // Contiene las opciones de los selectores del formulario de creacion de pestaña
  options = {};
  // Contiene los controles del formulario de creacion de pestaña
  controls: BaseControl<any>[] = [];
  // Contiene los formularios relacionados a guardar
  forms: SubForma[] = [];
  // Contiene los formularios guardados
  formsSaved: SubForma[] = [];
  // Contiene las opciones de las pestañas
  optionsForms: Option[] = [];
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia a la plantilla para el control personalizado de ng-select para las columnas de formularios o maestras
  @ViewChild('ngSelect') ngSelectTpl: TemplateRef<any>;
  // Referencia del selector de pestañas
  @ViewChild('selectTab') selectTabTpl: TemplateRef<any>;
  // Modal de agregacion de tab
  @ViewChild('newTab') private newTabTpl: TemplateRef<any>;
  // Referencia del compoennte de creacion de formularios
  @ViewChildren('creationForm') private creationForm: QueryList<CreationFormComponent>;
  // salida del evento de cerrar
  @Output() close: EventEmitter<boolean> = new EventEmitter();
  // salida del evento de guardar el formulario
  @Output() saveForm: EventEmitter<SubForma | SubForma[]> = new EventEmitter();

  constructor(
    private modalService: BsModalService,
    private dffs: DynamicFormsFormService,
    private cdcds: CreationDynamicComponentDataService,
    private toastr: ToastrService,
  ) { }

  ngOnInit() {
    if (this.addForm) {
      this.idComponent--;
      this.idFormulario = this.idComponent;
    } else {
      this.idFormulario = this.formI.id_forma;
    }
    this.templates = {
      ngSelect: this.ngSelectTpl
    };
    this.formPrincipal = Static.copyObjet(this.formPrincipalI);
    this.optionsForms.push({
      key: 'Formulario principal',
      value: this.idFormulario
    });
    if (!this.addForm && this.formPrincipal.sub_formas && this.formPrincipal.sub_formas.length) {
      this.forms = filter(this.formPrincipal.sub_formas, form => {
        if (
          form.estilo['formulario_pestaña'] &&
          form.estilo['formulario_pestaña'] === this.formI.alias
        ) {
          return form;
        }
      });
      if (this.forms.length) {
        this.forms.forEach(form => {
          this.optionsForms.push({
            key: form.nombre,
            value: form.id_forma
          });
        });
      }
    }
    this.formTabs.controls['formTab'].setValue(this.idFormulario);
    this.formTabs.controls['formTab'].valueChanges.subscribe(data => this.loaderFormulario(data));
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Evento de cierre de componente de creación
   *
   * @param {*} event
   * @memberof DynamicFormsComponent
   */
  closeForm(event: any) {
    this.close.emit(event);
  }

  /**
   * Evento de confirmacion de guardar formulario creado
   *
   * @param {*} event
   * @memberof DynamicFormsComponent
   */
  save(event: any) {
    if (this.saveFormulario()) {
      const formPrincipal = find(this.formsSaved, {id_forma: this.idFormulario});
      if (formPrincipal) {
        if (!formPrincipal.tabla) {
          this.saveForm.emit(formPrincipal);
        } else {
          if (this.forms.length) {
            const subForms: SubForma[] = [formPrincipal];
            this.forms.forEach(form => {
              const formExist = find(this.formsSaved, {id_forma: form.id_forma});
              if (formExist) {
                subForms.push(formExist);
              } else {
                subForms.push(form);
              }
            });
            this.saveForm.emit(subForms);
          } else {
            this.saveForm.emit(formPrincipal);
          }
        }
      }
    }
  }

  /**
   * Evento de confirmacion de guardar formulario creado
   *
   * @param {*} event
   * @memberof DynamicFormsComponent
   */
  update(event: any) {
    if (this.saveFormulario()) {
      const formPrincipal = find(this.formsSaved, {id_forma: this.idFormulario});
      if (formPrincipal) {
        if (!formPrincipal.tabla) {
          this.saveForm.emit(formPrincipal);
        } else {
          if (this.forms.length) {
            const subForms: SubForma[] = [];
            this.forms.forEach(form => {
              const formExist = find(this.formsSaved, {id_forma: form.id_forma});
              if (formExist) {
                subForms.push(formExist);
              } else {
                subForms.push(form);
              }
            });
            this.saveForm.emit(subForms);
          } else {
            this.saveForm.emit(formPrincipal);
          }
        }
      }
    }
  }

  /**
   * Carga el formulario seleccionado en el selector
   *
   * @param {*} data
   * @param {boolean} [save=false]
   * @memberof DynamicFormsComponent
   */
  loaderFormulario(data: any, save: boolean = false) {
    let valid = true;
    if (!save) {
      valid = this.saveFormulario();
    }
    if (valid) {
      this.loading = true;
      setTimeout(() => {
        if (data === this.idFormulario) {
          this.idFormSeletc = 0;
        } else {
          this.idFormSeletc = data;
        }
        let form = find(this.formsSaved, f => f.id_forma === data);
        if (!form) {
          form = find(this.forms, f => f.id_forma === data);
        }
        this.formSelect = form;
        this.loading = false;
      });
    } else {
      this.formTabs.controls['formTab'].setValue(this.idFormSeletc ? this.idFormSeletc : this.idFormulario, {
        onlySelf: false,
        emitEvent: false,
        emitModelToViewChange: true,
        emitViewToModelChange: true
      });
    }
  }

  /**
   * Guarda el formulario temporal
   *
   * @returns {boolean}
   * @memberof DynamicFormsComponent
   */
  saveFormulario(): boolean {
    if (this.creationForm && this.creationForm.first) {
      const form = this.creationForm.first.saveNewForm(true);
      if (form) {
        const indexForm = findIndex(this.formsSaved, {id_forma: form.id_forma});
        if (indexForm === -1) {
          this.formsSaved.push(form);
        } else {
          this.formsSaved[indexForm] = form;
        }
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  /**
   * Abre el formulario de creacion de pestaña
   *
   * @memberof DynamicFormsComponent
   */
  openNewTab() {
    if (this.formTabs.valid && this.formTabs.value['formTab'] && this.creationForm.first) {
      const fields = filter(this.creationForm.first.controlsPalette, ctrl => {
        if (ctrl.tipo_campo.nombre === 'ngSelect' && ctrl.lista_maestra.length) {
          return ctrl;
        }
      });
      if (fields.length) {
        const columns: Option[] = [];
        fields.forEach(ctrl => {
          columns.push({
            key: ctrl.label,
            value: ctrl.alias
          });
        });
        this.options['columns'] = columns;
      } else {
        this.options['columns'] = [];
      }
    } else {
      this.options['columns'] = [];
    }
    this.controls = this.dffs.getControlsNewForm(this.templates, this.options);
    this.modalRef = this.modalService.show(
      this.newTabTpl,
      { class: 'modal-lg-personalized', ignoreBackdropClick: true }
    );
  }

  /**
   * Cierra el formulario de pestaña
   *
   * @memberof DynamicFormsComponent
   */
  closeFormTab() {
    this.modalRef.hide();
    this.modalRef = null;
    this.controls = [];
  }

  /**
   * Controla los cambios en el formulario de agregar pestaña
   *
   * @param {*} data
   * @memberof DynamicFormsComponent
   */
  async changeFormNewTab(data: any) {
    if (data.change) {
      if (data.controlChanged === 'cboColumnaRelacion') {
        const field = find(this.creationForm.first.controlsPalette, {alias: data.change['cboColumnaRelacion']});
        const dataTemporal = Static.copyObjet(data.change);
        dataTemporal['cboValorRelacion'] = null;
        if (field) {
          this.loadingOptionsControl(field).then(_res => {
            this.refreshForm(dataTemporal);
          });
        } else {
          delete this.options['optColumnMaster'];
          this.refreshForm(dataTemporal);
        }
      }
    }
  }

  /**
   * Agregar pestaña
   *
   * @param {*} data
   * @memberof DynamicFormsComponent
   */
  addTab(data: any) {
    if (this.creationForm && this.creationForm.first) {
      const valid = this.saveFormulario();
      const formPrincipal = find(this.formsSaved, {id_forma: this.idFormulario});
      if (valid) {
        this.idComponent--;
        const newForm: SubForma = {
          id_forma: this.idComponent,
          orden: this.order,
          tabla: false,
          nombre: data.txtNombreFormulario,
          alias: data.txtAlias,
          estilo: {
            numero_registros_maximos: 0,
            registro_unico: false,
            formulario_pestaña: formPrincipal.alias,
            columna_pestaña: data.cboColumnaRelacion,
            valor_columna_pestaña: data.cboValorRelacion
          },
          sub_formulario: null,
          condiciones: [],
          asociaciones: [],
          numero_registros: 0,
        };
        this.forms.push(newForm);
        this.optionsForms.push({
          key: newForm.nombre,
          value: newForm.id_forma
        });
        this.closeFormTab();
        this.formTabs.controls['formTab'].setValue(newForm.id_forma, {
          onlySelf: false,
          emitEvent: false,
          emitModelToViewChange: true,
          emitViewToModelChange: true
        });
        this.loaderFormulario(newForm.id_forma, true);
      }
    }
  }

  /**
   * Eliminar pestaña
   *
   * @memberof DynamicFormsComponent
   */
  deleteTab() {
    if (this.formTabs.controls['formTab'].value) {
      if (this.formTabs.controls['formTab'].value === this.idFormulario) {
        this.toastr.warning('No puede eliminar el formulario principal', 'Acción no permitida');
      } else {
        const formSaveIndex = findIndex(this.formsSaved, f => f.id_forma === this.formTabs.controls['formTab'].value);
        const formIndex = findIndex(this.forms, f => f.id_forma === this.formTabs.controls['formTab'].value);
        const optionIndex = findIndex(this.optionsForms, f => f.value === this.formTabs.controls['formTab'].value);
        if (formIndex) {
          this.forms.splice(formIndex, 1);
        }
        if (formSaveIndex) {
          this.formsSaved.splice(formSaveIndex, 1);
        }
        if (optionIndex) {
          this.optionsForms.splice(optionIndex, 1);
        }
        this.formTabs.controls['formTab'].setValue(this.idFormulario, {
          onlySelf: false,
          emitEvent: false,
          emitModelToViewChange: true,
          emitViewToModelChange: true
        });
        this.loaderFormulario(this.idFormulario, true);
      }
    }
  }

  /**
   * Refresca el formulario de agregar pestaña
   *
   * @param {*} [data]
   * @memberof DynamicFormsComponent
   */
  private refreshForm(data?: any) {
    const dataTemporal = {
      label: data.txtNombreFormulario,
      alias: data.txtAlias,
      column: data.cboColumnaRelacion,
      valorRelacion: data.cboValorRelacion
    };
    this.controls = this.dffs.getControlsNewForm(this.templates, this.options, dataTemporal);
  }

  /**
   * Carga los datos de la maestra del select indicado
   *
   * @private
   * @param {Control} control
   * @returns {Promise<boolean>}
   * @memberof DynamicFormsComponent
   */
  private loadingOptionsControl(
    control: Control
  ): Promise<boolean> {
    return new Promise<boolean>(async (resolve, _reject) => {
      if (control.tipo_campo.nombre === 'ngSelect') {
        const columnsMaster: Array<{
          key: string,
          value: number
        }> = [];
        if (control.propiedades.tipo === 'TablaMaestra') {
          let specificEstructure: EstructuraEspecifica;
          specificEstructure = {
            maestra: String(control.lista_maestra[0].id),
            columnas: [],
            dependencia: []
          };
          let columns: ValoresEspecificos[];
          control.propiedades['columnas_seleccionadas'].forEach((col: string, index: number) => {
            const cols = col.split('_');
            const column = Number(cols[0]);
            if (cols.length === 1) {
              const structure = find(control.lista_maestra[0].estructura, {id: column});
              if (structure) {
                specificEstructure.columnas.push(column + ' ');
              }
            }
          });

          if (control.propiedades['columnas_seleccionadas'].length) {
            const blockColumns: Array<string[]> = [];
            if (control.propiedades['columnas_seleccionadas']) {
              let columnDependence = '';
              control.propiedades['columnas_seleccionadas'].forEach((col: string, index: number) => {
                const column = col.split('_');
                if (column.length > 1) {
                  if (columnDependence !== column[0]) {
                    columnDependence = column[0];
                    const blockColumnsRecolector: Array<string> = [];
                    control.propiedades['columnas_seleccionadas'].forEach((colDep: string, indexDep: number) => {
                      const columnsRef = colDep.split('_');
                      if (columnsRef[0] === columnDependence) {
                        blockColumnsRecolector.push(colDep);
                      }
                    });
                    blockColumns.push(blockColumnsRecolector);
                  }
                }
              });
              blockColumns.forEach(columnsSeleted => {
                const history = this.loadingEstructureColumns(
                  control.lista_maestra[0]['estructura'],
                  columnsSeleted,
                  Number(columnsSeleted[0].split('_')[0])
                );

                if (history) {
                    specificEstructure.dependencia.push(history);
                }
              });
            }
          }
          columns = await this.cdcds.getColumnsSpecificMasterTable(specificEstructure);

          columns.forEach(column => {
            let labelSelect = '';
            control.propiedades['columnas_seleccionadas'].forEach((col: number, index: any) => {
              if (index > 0) {
                labelSelect += ' / ';
              }
              if (column.valores[col]) {
                labelSelect += column.valores[col] ;
              } else {
                labelSelect += 'No aplica';
              }
            });
            columnsMaster.push({value: column.id, key: labelSelect});
          });
          this.options['optColumnMaster'] = columnsMaster;
          resolve(true);
        } else {
          delete this.options['optColumnMaster'];
          resolve(true);
        }
      } else {
        delete this.options['optColumnMaster'];
        resolve(true);
      }
    });
  }

  /**
   * Realiza la estructura para la consulta de las columnas seleccionadas para mostrar en las tablas y selects
   *
   * @private
   * @param {ColumnaMaestra[]} structure
   * @param {Array<string>} columns
   * @param {number} [idDependence=0]
   * @returns {EstructuraEspecifica}
   * @memberof DynamicFormsComponent
   */
  private loadingEstructureColumns(
    structure: ColumnaMaestra[],
    columns: Array<string>,
    idDependence: number = 0
  ): EstructuraEspecifica {
    let specificEstructure: EstructuraEspecifica;
    const cls: Array<string> = [];
    specificEstructure = {
      maestra: null,
      columnas: [],
      dependencia: []
    };
    columns.forEach(el => {
      cls.push(el);
    });
    for (const field of structure) {
      if (field.tipo_campo['nombre'] === 'ngSelect') {
        if (idDependence !== 0 && idDependence !== field.id) {
          continue;
        }
        specificEstructure.maestra = field.id + ' ';
        cls.forEach((col: string, index: number) => {
          const  cols = col.split('_');
          const column = Number(cols[1]);
          if (cols.length === 2) {
            const dependenc = Number(cols[0]);
            if (typeof field.maestra_dependencia === 'object') {
              const columnField = find(field.maestra_dependencia.estructura, {id: column});
                if (dependenc === field.id) {

                if (columnField) {
                  specificEstructure.columnas.push(column + ' ');
                }
              }
            }
          } else if (cols.length > 2) {
            const cl = cols.slice(1);
            cls[index] = '';
            cl.forEach((el: any, indexCol: number) => {
              cls[index] += el;

              if (indexCol < (cl.length - 1)) {
                cls[index] += '_';
              }

            });
          }
        });
        if (cls.length) {
          const newLevel = this.loadingEstructureColumns(field.maestra_dependencia['estructura'], cls);
          if (newLevel) {
            specificEstructure.dependencia.push(newLevel);
            break;
          }
        }
      }
    }
    if (specificEstructure.maestra && (specificEstructure.columnas.length || specificEstructure.dependencia.length)) {
      return specificEstructure;
    } else {
      return null;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/dynamic-forms/dynamic-forms.component.ts